import PageContainer from "../../../components/global/PageContainer"
import Title from "../../../components/global/Title"
import ResourceCard from "../../../components/library/ResourceCard"
import { Grid } from "@mui/material"
import { useMemo } from "react"
import File from "../../../models/file"
import FadeFromTop from "../../../components/animations/FadeFromTop"
import { useTranslation } from "react-i18next"

const UsageGuide = () => {
  const { t, i18n } = useTranslation()

  // array of files
  const files: File[] = useMemo(
    () => [
      {
        uri:
          i18n.language === "it"
            ? "https://drive.google.com/file/d/1m3-ho_NaOJeTl20cAIMNAzp7Y44xWNEa"
            : "https://drive.google.com/file/d/1ivkyfHDyq2eTx8-Vclf7BK_FK-TLVMe6",
        title: t("usage_guide"),
      },
    ],
    [t]
  )

  return (
    <PageContainer
      title={t("usage_guide")}
      breadcrumbs={[
        { title: t("operational_kit"), path: "/library" },
        { title: t("usage_guide") },
      ]}
      withFilters={false}
      withDatePicker={false}
      withExportButton={false}
      paddingTop={24}
    >
      <Title fontSize={14}>{t("usage_guide_description")}</Title>
      <Grid container spacing={3} columns={3} style={{ marginTop: 16 }}>
        {files.map((file, index) => (
          <Grid item xs={3} md={1} key={index}>
            <FadeFromTop delay={0.025 * index} style={{ height: "100%" }}>
              <ResourceCard file={file} />
            </FadeFromTop>
          </Grid>
        ))}
      </Grid>
    </PageContainer>
  )
}

export default UsageGuide
